import { RootContext } from 'context/root/RootContext';
import { useRootLogic } from 'hooks/root-logic/root/use-root-logic';
import type { Children } from 'models';

export const RootLogicProvider = ({ children }: Children) => {
  const value = useRootLogic();

  return <RootContext.Provider {...{ value }}>{children}</RootContext.Provider>;
};
